/**
 * Apply a normalized manual-document upload result to a TipTap editor.
 * Same behavior as Elaborar Contrato upload (replace vs append confirm).
 *
 * @param {import('@tiptap/core').Editor} editor
 * @param {{ ok: true; kind: 'html'; html: string } | { ok: true; kind: 'tiptap_json'; document: object } | { ok: false; message?: string }} result
 * @param {string} docLabel
 * @param {{
 *   confirmReplace?: boolean;
 *   allowFieldTokenDeletionOnReplace?: boolean;
 *   replaceAllEditorContent?: (editor: import('@tiptap/core').Editor, content: unknown, parseOptions?: object) => boolean;
 *   onBeforeReplace?: () => void;
 * }} [options]
 * @returns {{ ok: true; replaced: boolean } | { ok: false; message: string }}
 */
export function applyManualDocumentUploadToEditor(
  editor,
  result,
  docLabel = 'DOCX',
  {
    confirmReplace = true,
    allowFieldTokenDeletionOnReplace = false,
    replaceAllEditorContent = null,
    onBeforeReplace = null,
  } = {}
) {
  if (!editor) {
    return { ok: false, message: 'Editor indisponível.' };
  }

  if (!result?.ok) {
    return {
      ok: false,
      message: result?.message || `Não foi possível processar o ${docLabel}.`,
    };
  }

  let replace = true;
  if (confirmReplace) {
    replace = window.confirm(
      `O ${docLabel} foi processado. Deseja substituir todo o conteúdo do editor?\n\n` +
        'OK = substituir. Cancelar = inserir no final do documento.'
    );
  }

  const parseOpts = { parseOptions: { preserveWhitespace: false } };
  const setAllContent = (content) => {
    if (allowFieldTokenDeletionOnReplace && typeof replaceAllEditorContent === 'function') {
      return replaceAllEditorContent(editor, content, parseOpts.parseOptions);
    }

    editor.commands.clearContent();
    return editor.commands.setContent(content, parseOpts);
  };

  if (replace) {
    onBeforeReplace?.();
  }

  if (result.kind === 'tiptap_json') {
    if (replace) {
      setAllContent(result.document);
    } else {
      editor.chain().focus('end').insertContent(result.document).run();
    }
  } else {
    const html = result.html;
    if (replace) {
      setAllContent(html);
    } else {
      const current = (editor.getHTML() || '').trim();
      const emptyish = !current || current === '<p></p>';

      if (emptyish) {
        setAllContent(html);
      } else {
        editor.chain().focus('end').insertContent(html, parseOpts).run();
      }
    }
  }

  return { ok: true, replaced: replace };
}
